import { render, staticRenderFns } from "./SFXData.vue?vue&type=template&id=7f6a29d5&"
import script from "./SFXData.vue?vue&type=script&lang=js&"
export * from "./SFXData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports